import { SavedItemsSdkConfig } from "../sdk";
import type { SavedItemsState } from "./state.types";

export type SdkMethodContext = SavedItemsSdkConfig & {
  xSiteOrigin?: string;
  getAuthHeader: () => Promise<string>;
  state: {
    getSavedItemsState: () => SavedItemsState;
    setSavedItemsState: (newItems: SavedItemsState) => void;
  };
};

export type SavedItemsSdkMethod<T> = (context: SdkMethodContext) => T;

export function initializeMethod<T>(
  context: SdkMethodContext,
  method: SavedItemsSdkMethod<T>,
): T {
  return method(context);
}
